import { User } from "../types/auth";

export const hasCapability = (
  user: User | null | undefined,
  codename: string
): boolean => !!user?.capabilities?.some((c) => c.codename === codename);

/**
 * True when the user holds the RESTRICTIVE `view_only` capability: they can
 * view projects but cannot create, edit, or delete anything. Staff users are
 * never view-only. The backend enforces this globally; the frontend uses it
 * to hide edit affordances.
 */
export const isViewOnly = (user: User | null | undefined): boolean =>
  !!user && !user.is_staff && hasCapability(user, "view_only");
